function pro3_find_parking_form(form) {

	var input = $('input[type="search"]', form)[0];
	var options = {
		componentRestrictions: {
			country: ['us']
		}
	};

	var autocomplete = new google.maps.places.Autocomplete(input, options);
	autocomplete.addListener('place_changed', function () {
		var place = autocomplete.getPlace();
		var lat = place.geometry.location.lat();
		var lng = place.geometry.location.lng();
		// convert offset to seconds
		var offset = place.utc_offset_minutes * 60;
		$(input).attr({
			'data-latitude': lat,
			'data-longitude': lng,
			'data-offset': offset
		});
	});

	// allow choosing locations with keyboard
	$('input[type="search"]', form).on('keydown', function(e) {
		if (e.which === 13 && $('.pac-container:visible').length) {
			return false;
		}
	});

	$(form).on('submit', function(e) {
		e.preventDefault();

		$('.button-spinner', form).prop('disabled', true);

		var now = moment();
		var date = new Date();
		// var input = $('input[type="search"]', form);
		var type = 'hourly';
		var start_date = GetDateStr(date);
		var start_time = GetTimeNearest30(date);
		var lat = $(input).attr('data-latitude');
		var lng = $(input).attr('data-longitude');
		var address = $(input).val();
		var offset = $(input).attr('data-offset');
		var nonce = $('input[name="autocomplete-form-nonce"]', form).val();
		console.log(type, start_date, start_time, lat, lng, address, offset, nonce);

		$.ajax({
			type: 'post',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'initial_search_query',
				parkingType: type,
				address: address,
				latitude: lat,
				longitude: lng,
				startTime: start_time,
				startDate: start_date,
				offset: offset,
				nonce: nonce
			},
			success: function(results) {
				var results = JSON.parse(results);
				console.log(results);
				if (results.status == 'success') {
					if (results.match == true) {
						var url = new URL(results.location.permalink);
						url.searchParams.set('type', results.parkingType);
						window.location.href = url.href;
					} else {
						var url = new URL(window.location.href);
						url.pathname = '/search/';
						url.searchParams.set('type', results.parkingType);
						url.searchParams.set('startDate', start_date);
						url.searchParams.set('startTime', start_time);
						url.searchParams.set('lat', results.latitude);
						url.searchParams.set('lng', results.longitude);
						url.searchParams.set('address', encodeURIComponent(results.address));
						url.searchParams.set('offset', results.offset);
						console.log('url:', url);
						window.location.href = url.href;
					}
				} else {
					console.log('error!', results.message);
					$('.button-spinner', form).prop('disabled', false);
				}
			},
			error: function (results) {
				var results = JSON.parse(results);
				console.log(results);
				$('.button-spinner', form).prop('disabled', false);
			}
		});
	});

}

$(document).ready(function() {

	var forms = $('.pro3-find-parking-form');
	if (forms.length > 0) {
		$(forms).each(function(index, form) {
			pro3_find_parking_form(form);
		});
	}

	// simple map on custom facility landing page
	$('.pro3-half-and-half-map').each(function(index, element) {
		var id = $(element).attr('id');
		var lat = $(element).attr('data-latitude');
		var lng = $(element).attr('data-longitude');
		simpleMap(lat, lng, id);
	});

	// block :: big photo tabs
	$('.pro3-big-photo-tabs').each(function(index, element) {
		var photo_tabs_slider = $('.pro3-big-photo-tabs-group', element).flickity({
			adaptiveHeight: true,
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			percentPosition: true,
			prevNextButtons: false,
			resize: true
		});
		$('.pro3-big-photo-tabs-menu', element).on('click', '.pro3-big-photo-tabs-menu-button', function() {
			var index = $(this).attr('data-index');
			var buttons = $(this).siblings();
			$(buttons).removeClass('pro3-big-photo-tabs-menu-button-active');
			$(this).addClass('pro3-big-photo-tabs-menu-button-active');
			photo_tabs_slider.flickity('select', index);
		});
	});

	// block :: blog posts
	$('.pro3-blog-posts-slider').each(function(index, element) {
		var blog_posts_slider = $(element).flickity({
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			// percentPosition: true,
			resize: true
		});
	});

	// block :: full width slider
	$('.pro3-full-width-image-slider').each(function(index, element) {
		var full_width_slider = $(element).flickity({
			cellAlign: 'left',
			contain: true
		});
	});

	// block :: map with statistics
	$('.pro3-statistics-group').each(function(index, element) {
		var statistics = $('.pro3-statistic', element);
		$(statistics).each(function(index, statistic) {
			var target = $('.pro3-statistic-number', statistic)[0];
			var end_number = $(target).attr('data-number') * 1;
			var prefix = $(target).attr('data-prefix');
			var suffix = $(target).attr('data-suffix');
			var options = {
				startVal: 0,
				duration: 3,
				useGrouping: false,
				useEasing: true,
				prefix: prefix,
				suffix: suffix,
				enableScrollSpy: true,
				scrollSpyOnce: true
			};
			var counter = new CountUp(target, end_number, options);
		});
	});

	// block :: resources index
	$('#pro3-blog-posts-content-type').on('change', function() {
		var value = $(this).val();
		window.location.href = value;
	});

	// block :: video & video grid
	$('.pro3-video-video').on('click', function() {
		$(this).addClass('pro3-video-video-clicked');
		var video_type = $(this).attr('data-video-type');
		console.log(video_type);
		if (video_type === 'embed') {
			var iframe = $(this).children('iframe');
			var src = $(iframe).attr('src');
			src = src + '&autoplay=1';
			$(iframe).attr('src', src);
		} else if (video_type === 'upload') {
			var video = $(this).children('video');
			$(video).get(0).play();
			console.log('video:', video);
		}
	});

	// block :: contact form tabs
	$('.pro3-contact-form-tabs-buttons-group').each(function(index, element) {
		$('.pro3-contact-form-tabs-button', element).on('click', function() {
			var tab = $(this).attr('data-tab');
			// manipulate buttons
			$('.pro3-contact-form-tabs-button', element).removeClass('pro3-contact-form-tabs-button-active');
			$(this).addClass('pro3-contact-form-tabs-button-active');
			// manipulate tabs
			$('.pro3-contact-form-tabs-content').removeClass('pro3-contact-form-tabs-content-active');
			$('.pro3-contact-form-tabs-content[data-tab="' + tab + '"]').addClass('pro3-contact-form-tabs-content-active');
		});
	});

});
